import axios from 'axios'
import { useAuthStore } from '../store/authStore'

const API_URL = import.meta.env.VITE_API_URL || '/api/v1'

let refreshPromise: Promise<string | null> | null = null

export async function refreshAccessToken(): Promise<string | null> {
  const refreshToken = useAuthStore.getState().refreshToken
  if (!refreshToken) return null

  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${API_URL}/auth/refresh`, { refresh_token: refreshToken })
      .then((response) => {
        const { access_token, refresh_token } = response.data
        useAuthStore.setState((state) => ({
          ...state,
          accessToken: access_token,
          refreshToken: refresh_token,
        }))
        return access_token as string
      })
      .catch(() => {
        useAuthStore.getState().logout()
        window.location.href = '/login'
        return null
      })
      .finally(() => {
        refreshPromise = null
      })
  }
  return refreshPromise
}

export async function authenticatedFetch(
  input: string,
  init: RequestInit = {},
): Promise<Response> {
  const doFetch = async (token: string | null) => {
    const headers = new Headers(init.headers)
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    if (!headers.has('Content-Type') && init.body) {
      headers.set('Content-Type', 'application/json')
    }
    return fetch(input, { ...init, headers })
  }

  let token = useAuthStore.getState().accessToken
  let response = await doFetch(token)

  if (response.status === 401) {
    if (!useAuthStore.getState().refreshToken) {
      useAuthStore.getState().logout()
      window.location.href = '/login'
      return response
    }
    token = await refreshAccessToken()
    if (token) {
      response = await doFetch(token)
    }
  }

  return response
}

export { API_URL }
